export default __webpack_public_path__ + "static/media/page2.f66434d3.png";